export const SET_CURRENT_WORKSPACE = 'SET_CURRENT_WORKSPACE';
export const SET_WORKSPACES = 'SET_WORKSPACES';
export const SET_CURRENT_APP = 'SET_CURRENT_APP';
export const SET_ERROR = 'SET_ERROR';
export const ADD_INSTALLED_APP = 'ADD_INSTALLED_APP';
export const REMOVE_INSTALLED_APP = 'REMOVE_INSTALLED_APP';
export const CLEAR_INSTALLED_APPS = 'CLEAR_INSTALLED_APPS';
